module.exports = __webpack_public_path__ + "img/new_shipinfengmian.44e9e496.png";